import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Alert,
  Button,
  CircularProgress,
  Stack,
  TextField,
} from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { MFA_CODE_LENGTH } from "constants/index";

import type { WriterComponentState } from "hooks/useWriterComponentState";

interface Props {
  phoneNumber: string;
  verificationCode: string;
  onCodeChange: (value: string) => void;
  onVerify: VoidFunction;
  onResend: VoidFunction;
  onTryDifferentNumber: VoidFunction;
  verifyCodeWriter: WriterComponentState;
  resendCodeWriter: WriterComponentState;
}

export function CodeVerificationStep(props: Props) {
  const {
    phoneNumber,
    verificationCode,
    onCodeChange,
    onVerify,
    onResend,
    onTryDifferentNumber,
    verifyCodeWriter,
    resendCodeWriter,
  } = props;

  return (
    <Stack spacing={2}>
      <Button
        variant="text"
        size="small"
        startIcon={<ArrowBackIcon />}
        onClick={onTryDifferentNumber}
        sx={{ alignSelf: "flex-start", pl: 0 }}
      >
        Try a different number
      </Button>
      <Alert severity="info">
        A verification code has been sent to <strong>{phoneNumber}</strong>
      </Alert>
      <TextField
        label="6-Digit Verification Code"
        value={verificationCode}
        onChange={(e) => {
          onCodeChange(e.target.value.replace(/\D/g, ""));
        }}
        inputProps={{
          maxLength: MFA_CODE_LENGTH,
          style: {
            textAlign: "center",
            letterSpacing: "0.5rem",
            fontFamily: "monospace",
            fontSize: "1.1rem",
          },
        }}
        autoFocus
      />
      <ErrorTypography error={verifyCodeWriter.error} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Button
          variant="text"
          size="small"
          onClick={onResend}
          disabled={resendCodeWriter.loading}
        >
          {resendCodeWriter.loading ? "Sending..." : "Resend code"}
        </Button>
        {verifyCodeWriter.loading ? (
          <CircularProgress size={36} />
        ) : (
          <Button
            variant="contained"
            color="success"
            onClick={onVerify}
            disabled={verificationCode.length !== MFA_CODE_LENGTH}
          >
            Verify Code
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
